
import gql from 'graphql-tag'
// 退款单列表
export const findRefunds = gql`
  query($order: [RefundsFindOrder!],$paging: PagingQuery,$where: RefundsFindFilter) {
    findRefunds(
      order: $order,
      paging: $paging,
      where: $where
    ) {
      refunds {
        account
        channel
        createdAt
        description
        id
        indexNumber
        refundWay
        auditStatus
        order {
          id
          transactionNumber
          orderNumber
          period
          dealer {
            realname
            storePhone
          }
          address {
            phone
            realname
            className
            year
            school {
              name
            }
          }
        }
        orderId
        queryTriedTimes
        recvAccount
        refundNumber
        status
        successTime
        totalAmount
        totalPrice
        transactionNumber
        type
        updatedAt
      }
      paging {
        currentOffset
        take
        totalCount
      }
    }
  }
`

export const createRefund = gql`
  mutation($description: String , $orderId: Int! , $refundWay:RefundWay!) {
    createRefund(
      description: $description,
      orderId: $orderId 
      refundWay: $refundWay
    )
  }
`

export const cancelRefund = gql`
  mutation($orderId:Int!){
    cancelRefund(orderId:$orderId)
  }
`

export const exportRefundsList = gql`
  query($order: [RefundsFindOrder!],$where: RefundsFindFilter) {
    exportRefundsList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
